var $02afdaf6eedc1651$exports = {};
$02afdaf6eedc1651$exports = {
    "breadcrumbs": `\u{422}\u{440}\u{43E}\u{445}\u{438} \u{445}\u{43B}\u{44F}\u{431}`
};


export {$02afdaf6eedc1651$exports as default};
//# sourceMappingURL=bg-BG.mjs.map
